<template>
  <div>
    <CheckBox :id="id" v-model="model">
      <slot>{{ label }}</slot>
    </CheckBox>

    <ValidationError :validation="validation" />
  </div>
</template>

<script setup lang="ts">
import { CheckBox } from '@ramp106/omrjs-core-ui'
import type { BaseValidation } from '@vuelidate/core'

import ValidationError from '@/components/CreateJob/ValidationError.vue'

interface FormCheckboxFieldProps {
  id?: string
  label?: string
  validation: BaseValidation
}

const model = defineModel<boolean>()
defineProps<FormCheckboxFieldProps>()
</script>
